// Import the functions you need from the SDKs you need
import { initializeApp } from "firebase/app";
import { getAnalytics } from "firebase/analytics";
import { getAuth } from "firebase/auth";
import { getFirestore, initializeFirestore, persistentLocalCache, persistentMultipleTabManager } from "firebase/firestore";
import { getDatabase } from "firebase/database";
import { initializeAppCheck, ReCaptchaV3Provider, ReCaptchaEnterpriseProvider } from "firebase/app-check";

// Your web app's Firebase configuration
// For Firebase JS SDK v7.20.0 and later, measurementId is optional
const firebaseConfig = {
  apiKey: "AIzaSyAHOo91bhnTq8Pja1geHMWvDNZ4PdcMPzc",
  authDomain: "vortex-c9404.firebaseapp.com",
  databaseURL: "https://vortex-c9404-default-rtdb.firebaseio.com",
  projectId: "vortex-c9404",
  storageBucket: "vortex-c9404.firebasestorage.app",
  messagingSenderId: "986028341879",
  appId: "1:986028341879:web:7e0d323e5b7f0f3841e472",
  measurementId: "G-D6C1417N6V"
};

// Initialize Firebase
const app = initializeApp(firebaseConfig);

// Initialize Analytics conditionally (only in production)
let analytics = null;
try {
  if (typeof import.meta !== 'undefined' && import.meta.env && import.meta.env.PROD) {
    analytics = getAnalytics(app);
  }
} catch (error) {
  // Silent catch for analytics
}

const auth = getAuth(app);
const database = getDatabase(app);

// Persistencia IndexedDB de Firestore: los quizzes personales y el perfil
// sobreviven recargas y se leen sin esperar a la red.
let db;
try {
  db = initializeFirestore(app, {
    localCache: persistentLocalCache({ tabManager: persistentMultipleTabManager() }),
  });
} catch (error) {
  console.warn('⚠️ No se pudo activar la persistencia local de Firestore:', error);
  db = getFirestore(app);
}

// App Check — Deshabilitado por defecto. Para activarlo:
// 1. Habilita reCAPTCHA Enterprise API en Google Cloud Console
// 2. Registra la clave en Firebase Console > App Check > reCAPTCHA Enterprise
// 3. Define VITE_ENABLE_APP_CHECK=true en el entorno de build
if (import.meta.env?.VITE_ENABLE_APP_CHECK === 'true') {
  try {
    const provider = import.meta.env?.VITE_RECAPTCHA_ENTERPRISE === 'true'
      ? new ReCaptchaEnterpriseProvider()
      : new ReCaptchaV3Provider(import.meta.env.VITE_RECAPTCHA_SITE_KEY || '');
    initializeAppCheck(app, {
      provider,
      isTokenAutoRefreshEnabled: true,
    });
  } catch (appCheckErr) {
    console.warn('⚠️ No se pudo inicializar App Check:', appCheckErr);
  }
}

export { app, analytics, auth, db, database };